export default __webpack_public_path__ + "static/media/ATrieuCPO.7777384d.png";